// The platform's product areas and feature flags (packages/shared/src), shared with the API, guides and merge-risk.
import productAreas from '@platform/shared/product-areas.json';
import featureFlags from '@platform/shared/feature-flags.json';

export interface ProductArea {
  key: string;
  name: string;
  description: string;
  order: number;
  internal: boolean;
}

export const PRODUCT_AREAS: ProductArea[] = [...productAreas].sort((a, b) => a.order - b.order);
export const CUSTOMER_AREAS = PRODUCT_AREAS.filter(area => !area.internal);
export const FEATURE_FLAGS: { code: string; label: string }[] = featureFlags;

const byKey = new Map(PRODUCT_AREAS.map(area => [area.key, area]));

export const areaName = (key: string) => byKey.get(key)?.name ?? key;
export const areaOrder = (key: string) => byKey.get(key)?.order ?? Number.MAX_SAFE_INTEGER;
export const isInternalArea = (key: string) => byKey.get(key)?.internal !== false;
